(function (factory) {
    var isModule = false;

    try {
        isModule = !!(define || module);
    } catch (error) {}

    if (isModule) {
        define('lib/radar', function (require, exports) {
            exports.radar = factory;
        });
    }

    return factory;
})(function (settings) {
    var prefix = settings.prefix;
    var email = settings.email;
    var pageId = settings.pageId;
    var idle = settings.idle;
    var o_ss = settings.o_ss;
    var o_v = settings.o_v
    var project = 'cloud';
    var baseUrl = settings.baseUrl || 'https://xray.mail.ru/update';

    if (prefix) {
        prefix = '_' + prefix;
    }

    var now =
        Date.now ||
        function () {
            return new Date().getTime();
        };

    var transport = {
        _options: {
            timeout: 3000,
        },

        _call: function (immediate, callback) {
            if (immediate) {
                try {
                    callback();
                } catch (reason) {}
            } else {
                /* TODO: avoid onLoad usage! */
                onLoad(function () {
                    if (window.requestIdleCallback) {
                        window.requestIdleCallback(callback);
                    } else {
                        window.setTimeout(callback, 0);
                    }
                });
            }
        },

        _createQueryString: function (queryParams) {
            var KEY = 0;
            var VALUE = 1;

            var queryString = '';

            for (var i = 0, length = queryParams.length; i < length; i++) {
                var queryParam = queryParams[i];
                var key = queryParam[KEY];
                var value = queryParam[VALUE];

                if (i) {
                    queryString += '&';
                }

                if (value === undefined) {
                    queryString += key;
                } else {
                    queryString += key + '=' + value;
                }
            }

            return queryString;
        },

        /* dumn legacy… TODO: use promises */
        _Deferred: function () {
            var PENDING = 0;

            var ALWAYS = 0;
            var DONE = 1;
            var FAIL = 2;

            var TYPE = 0;
            var CALLBACK = 1;

            var state = PENDING;
            var queue = [];
            var value;

            var deferred = {
                resolve: function (data) {
                    if (state === PENDING) {
                        state = DONE;
                        value = data;

                        for (var i = 0, length = queue.length; i < length; i++) {
                            var params = queue[i];
                            var type = params[TYPE];

                            if (type === DONE || type === ALWAYS) {
                                var callback = params[CALLBACK];

                                callback(value);
                            }
                        }

                        queue = null;
                    }

                    return deferred;
                },

                reject: function (reason) {
                    if (state === PENDING) {
                        state = FAIL;
                        value = reason;

                        for (var i = 0, length = queue.length; i < length; i++) {
                            var params = queue[i];
                            var type = params[TYPE];

                            if (type === FAIL || type === ALWAYS) {
                                var callback = params[CALLBACK];

                                callback(value);
                            }
                        }

                        queue = null;
                    }

                    return deferred;
                },

                always: function (callback) {
                    if (state === PENDING) {
                        queue.push([ALWAYS, callback]);
                    } else {
                        callback(value);
                    }

                    return deferred;
                },

                done: function (callback) {
                    if (state === PENDING) {
                        queue.push([DONE, callback]);
                    } else if (state === DONE) {
                        callback(value);
                    }

                    return deferred;
                },

                fail: function (callback) {
                    if (state === PENDING) {
                        queue.push([FAIL, callback]);
                    } else if (state === FAIL) {
                        callback(value);
                    }

                    return deferred;
                },

                then: function (onFulfilled, onRejected) {
                    deferred.done(onFulfilled);

                    if (onRejected) {
                        deferred.fail(onRejected);
                    }

                    return deferred;
                },

                catch: function (onRejected) {
                    deferred.fail(onRejected);

                    return deferred;
                },
            };

            return deferred;
        },

        iframe: function (url, queryParams, immediate) {
            var deferred = new this._Deferred();
            var timeoutId = 0;

            var onLoad = function () {
                this.onload = null;
                this.src = 'about:blank';
                window.clearTimeout(timeoutId);

                var parent = this.parentNode;

                if (parent) {
                    parent.removeChild(this);
                }

                deferred.resolve();
            };

            this._call(immediate, function () {
                var frame = document.createElement('iframe');

                frame.setAttribute('frameborder', 0);
                frame.setAttribute('style', 'width: 1px; height: 1px; position: absolute;');
                frame.onload = onLoad;

                timeoutId = window.setTimeout(function () {
                    frame.onload();
                    deferred.reject(new Error('time is out'));
                }, transport._options.timeout);

                frame.src = url + '?' + transport._createQueryString(queryParams);
                document.body.appendChild(frame);
            });

            return deferred;
        },

        xhr: function (url, queryParams, immediate) {
            var deferred = new this._Deferred();
            var timeoutId = 0;

            var onReadyStateChange = function () {
                var DONE = 4;

                if (this.readyState == DONE) {
                    this.onreadystatechange = null;
                    window.clearTimeout(timeoutId);

                    var status = this.status;

                    if (status >= 200 && status < 400) {
                        deferred.resolve();
                    } else {
                        var errorMessage;

                        if (status) {
                            errorMessage = 'HTTP ' + status + ' ' + this.statusText;
                        } else {
                            errorMessage = 'connection';
                        }

                        deferred.reject(new Error(errorMessage));
                    }
                }
            };

            this._call(immediate, function () {
                var xhr = new XMLHttpRequest();

                xhr.open('POST', url);
                xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                xhr.onreadystatechange = onReadyStateChange;

                timeoutId = window.setTimeout(function () {
                    // don't abort, just reject
                    xhr.onreadystatechange = null;
                    deferred.reject(new Error('time is out'));
                }, transport._options.timeout);

                xhr.send(transport._createQueryString(queryParams));
            });

            return deferred;
        },

        _beacon: function (url, queryParams, immediate) {
            var deferred = new this._Deferred();

            this._call(immediate, function () {
                var KEY = 0;
                var VALUE = 1;

                var formData = new FormData();

                for (var i = 0, length = queryParams.length; i < length; i++) {
                    var queryParam = queryParams[i];

                    formData.append(queryParam[KEY], queryParam[VALUE]);
                }

                if (navigator.sendBeacon(url, formData)) {
                    deferred.resolve();
                } else {
                    deferred.reject(new Error('not queued'));
                }
            });

            return deferred;
        },

        post: function (url, queryParams, immediate) {
            //if (navigator.sendBeacon) {
            //	return this._beacon(url, queryParams, immediate);
            //}

            return this.xhr(url, queryParams, immediate);
        },

        image: function (url, queryParams, immediate) {
            var deferred = new this._Deferred();
            var timeoutId = 0;

            var onLoad = function () {
                window.clearTimeout(timeoutId);
                this.onload = null;
                this.onerror = null;

                deferred.resolve();
            };

            var onError = function () {
                window.clearTimeout(timeoutId);
                this.onload = null;
                this.onerror = null;

                deferred.reject(new Error('loading failed'));
            };

            this._call(immediate, function () {
                var image = new Image();

                image.onload = onLoad;
                image.onerror = onError;

                timeoutId = window.setTimeout(function () {
                    image.onload = null;
                    image.onerror = null;

                    deferred.reject(new Error('time is out'));
                }, transport._options.timeout);

                image.src = url + '?' + transport._createQueryString(queryParams);
            });

            return deferred;
        },

        immediate: function (url, queryParams) {
            return this.image(url, queryParams, true);
        },

        beacon: function (url, queryParams, immediate) {
            if (navigator.sendBeacon) {
                return this._beacon(url, queryParams, immediate);
            }

            return this.image(url, queryParams, immediate);
        },

        beaconImmediate: function (url, queryParams) {
            return this.beacon(url, queryParams, true);
        },
    };

    var createCounter = function (mainLabel, mainValue) {
        var time = now();
        var mainTime = time;
        var data = [];
        var kaktam;

        var counter = {
            alreadySended: false,

            params: {},

            add: function (label, value) {
                if (!counter.alreadySended) {
                    data.push({
                        label: label,
                        time: now(),
                        value: value,
                    });
                }

                return counter;
            },

            timeEnd: function (label) {
                if (!counter.alreadySended) {
                    data.push({
                        label: label,
                        time: now(),
                        value: null,
                    });
                }

                return counter;
            },

            kaktam: function (file, message) {
                if (!counter.alreadySended) {
                    kaktam = {
                        file: file,
                        message: message,
                    };
                }

                return counter;
            },

            param: function (name, value) {
                if (!counter.alreadySended && name) {
                    counter.params[name] = value;
                }

                return counter;
            },

            _getData: function () {
                var result = '';

                for (var i = 0, length = data.length; i < length; i++) {
                    var mark = data[i];
                    var value;

                    if (mark.value === undefined) {
                        value = mark.time - time;
                    } else if (mark.value === null) {
                        value = mark.time - mainTime;
                    } else {
                        value = mark.value;
                    }

                    if (i) {
                        result += ',';
                    }

                    result += mark.label + ':' + value;
                    time = mark.time;
                }

                return result;
            },

            send: function (transportType) {
                if (counter.alreadySended) {
                    throw new Error("This counter '" + mainLabel + "' already sended to server");
                }

                counter.alreadySended = true;

                var queryParams = [];

                queryParams.push(['p', project]);
                queryParams.push(['t', mainLabel + prefix]);
                queryParams.push(['v', mainValue === undefined ? now() - mainTime : mainValue]);

                if (data.length) {
                    queryParams.push(['i', counter._getData()]);
                }

                data = null;

                queryParams.push(['rnd', Math.random()]);

                if (email) {
                    queryParams.push(['email', email]);
                }

                if (pageId) {
                    queryParams.push(['x-page-id', pageId]);
                }

                if (o_ss && o_v) {
                    queryParams.push(['o_ss', o_ss]);
                    queryParams.push(['o_v', o_v]);
                }

                var params = counter.params;

                for (var key in params) {
                    if (params.hasOwnProperty(key)) {
                        queryParams.push([key, encodeURIComponent(params[key])]);
                    }
                }

                counter.params = null;

                if (kaktam) {
                    queryParams.push(['rlog', project + '_' + kaktam.file]);
                    queryParams.push(['rlog_message', encodeURIComponent(kaktam.message)]);
                    kaktam = null;
                }

                if (idle) {
                    console && console.debug && console.debug('radar:', queryParams);
                    counter.deferred = new transport._Deferred();
                    counter.deferred.resolve();
                } else {
                    switch (transportType) {
                        case 'iframe':
                        case 'beacon':
                        case 'immediate':
                        case 'beaconImmediate':
                            counter.deferred = transport[transportType](baseUrl, queryParams);
                            break;

                        case 'post':
                            var postUrl = baseUrl + '?xpost=' + mainLabel + prefix;

                            counter.deferred = transport.post(postUrl, queryParams);
                            break;

                        default:
                            counter.deferred = transport.image(baseUrl, queryParams);
                    }
                }

                return counter;
            },

            after: function (callback) {
                var deferred = counter.deferred;

                if (deferred) {
                    deferred.always(callback);
                }

                return counter;
            },
        };

        return counter;
    };

    var radar = function (label, value, transportType) {
        return createCounter(label, value).send(transportType);
    };

    radar.ts = now;

    radar.post = function (label, value) {
        return createCounter(label, value).send('post');
    };

    radar.immediate = function (label, value) {
        return createCounter(label, value).send('immediate');
    };

    radar.beacon = function (label, value) {
        return createCounter(label, value).send('beacon');
    };

    radar.beaconImmediate = function (label, value) {
        return createCounter(label, value).send('beaconImmediate');
    };

    radar.error = function (label, transportType) {
        return createCounter('error_' + label).send(transportType);
    };

    radar.group = function (label, value, transportType) {
        return createCounter(label, value, transportType);
    };

    radar.deferred = function (label, deferred, transportType) {
        var group = createCounter(label);

        deferred
            .done(function () {
                group.add('success');
            })
            .fail(function () {
                group.add('error');
            })
            .always(function () {
                group.send(transportType);
            });

        return deferred;
    };

    function iReplacer(i) {
        return i.toString().replace(/[^a-zA-Z0-9-]/gi, '-');
    }

    radar.ga = function (i, b, category, action, label) {
        var _radar = radar.group('web-analytics');

        if (typeof category !== 'string') {
            var params = category;

            category = params.eventCategory;
            action = params.eventAction;
            label = params.eventLabel;
        }

        var counter = iReplacer(category) + '_' + iReplacer(action);

        if (label) {
            _radar.add(counter, 1);

            counter += '_' + iReplacer(label);
        }

        console &&
        console.info &&
        console.info('DWH GA: category - "' + category + '", action - "' + action + '", label - "' + label + '"');

        _radar.add(counter, 1);

        _radar.send();

        gtag('event', action, {
            event_category: category,
            event_label: label,
        });
    };

    return radar;
    /* don't paste semicolon or newline at EOF, TODO: refactor to module */
    // disable-eslint-sameline
})